import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class IntervinientesService {

  INnombre:string = "";
  INemail:string = "";
  INtelefono:string = "";
  INperfil="";
  INactivo:number=1;
  INfechaultimoacceso="";
  
  intervinientes:any[]=[];
  listaIntervinientes=[];
  listaPerfiles=[];
    constructor( private http:HttpClient ) { }

    getIntervinientes( filtro, pagina, ordenacion ){

      filtro.nombre==""?this.INnombre="-":this.INnombre=filtro.nombre;
      filtro.email==""?this.INemail="-":this.INemail=filtro.email;
      filtro.telefono==""?this.INtelefono="-":this.INtelefono=filtro.telefono;
      filtro.perfil==""?this.INperfil="-":this.INperfil=filtro.perfil;
      filtro.activo==true?this.INactivo=1:this.INactivo=0;
      filtro.ultimoacceso==""?this.INfechaultimoacceso="-":this.INfechaultimoacceso=filtro.ultimoacceso;
      return this.http.get( `https://app.solucionlegal.es/API/index.php/Intervinientes/intervinientes/${this.INnombre}/${this.INemail}/${this.INtelefono}/${this.INperfil}/${this.INactivo}/${this.INfechaultimoacceso}/${pagina}/${ordenacion.campo}/${ordenacion.orden}` )
        .map(resp=>{
          this.intervinientes=resp["intervinientes"];
          return resp;
        })
    }

    getInterviniente(codInterviniente){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/Intervinientes/interviniente/${codInterviniente}`)
      .map(resp=>{
        return resp;
      })
    }

    getNombresIntervinientes(){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/nombresintervinientes`)
      .map(resp=>{
        this.listaIntervinientes=resp["intervinientes"];
      });
    }

    getNombresIntervinientesCliente(codcliente){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/nombresintervinientesCliente/${codcliente}`)
      .map(resp=>{
        this.listaIntervinientes=resp["intervinientes"];
      });
    }

    getNombresIntervinientesClientePymes(codcliente){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/nombresIntervinientesClientePymes/${codcliente}`)
      .map(resp=>{
        this.listaIntervinientes=resp["intervinientes"];
      });
    }

    getPerfiles(){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/perfiles`)
      .map(resp=>{
        this.listaPerfiles=resp["perfiles"];
        return resp;
      })
    }

    actualizarEstado(codInterviniente){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/actualizarEstado/${codInterviniente}`)
      .map(resp=>{
        return resp;
      });
    }

    insertInterviniente(interviniente){
      let body=JSON.stringify(interviniente);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/intervinientes/insertInterviniente`, body)
      .map(resp=>{
        return resp;  
      });
    }

    updateInterviniente(interviniente){
      let body=JSON.stringify(interviniente);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/intervinientes/updateInterviniente/${interviniente.INcodigo}`, body)
      .map(resp=>{
        return resp;  
      });
    }

    cambiarPass(interviniente){
      let body=JSON.stringify(interviniente);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/intervinientes/cambiarPass`, body)
      .map(resp=>{
        return resp;
      });
    }

    borrarInterviniente(codInterviniente){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/intervinientes/interviniente/${codInterviniente}`)
      .map(resp=>{
        return resp;
      })
    }

}



// WEBPACK FOOTER //
// ./src/app/services/intervinientes.service.ts